import {DataTableRpc} from '@/components/dataTableRpc';

import {useDistributor} from '../providers/distributorProvider';

export const renderInventoryTableStats = (
  totalInventory: number,
  activeInventory: number,
  inactiveInventory: number
) => [
  {
    title: 'Total Inventory',
    value: totalInventory,
    subtitle: 'This Month',
    change: 1.03,
    icon: 'ri-price-tag-3-line',
    color: 'primary',
    cardClass: 'Brands-main-card primary',
  },
  {
    title: 'Active Inventory',
    value: activeInventory,
    subtitle: 'This Month',
    change: 0.36,
    icon: 'ri-check-line',
    color: 'secondary',
    cardClass: 'Brands-main-card secondary',
  },
  {
    title: 'Inactive Inventory',
    value: inactiveInventory,
    subtitle: 'This Month',
    change: -1.28,
    icon: 'ri-close-line',
    color: 'warning',
    cardClass: 'Brands-main-card warning',
  },
];

/**
 * Distributor Detail Brands Component
 * @returns {JSX.Element}
 */
export const DistributorDetailInventory = () => {
  const {distributorId} = useDistributor();

  return (
    <>
      {/* <StatsRowComponent stats={stats} /> */}

      <DataTableRpc
        functionName="get_distributor_inventory_summary"
        functionArgs={{
          distributor_id_param: distributorId || 0,
        }}
        limit={5}
        sortOptions={[
          {column: 'inventory_count', direction: 'asc', label: 'Inventory Count ascending'},
          {column: 'inventory_count', direction: 'desc', label: 'Inventory Count descending'},
        ]}
        columns={[
          {
            header: 'Product Image',
            field: 'product_category',
          },
          {
            header: 'Product Name',
            field: 'product_name',
          },
          {
            header: 'Category',
            field: 'product_category',
          },
          {
            header: 'Subcategory',
            field: 'product_subcategory',
          },
          {
            header: 'Ancestor Category',
            field: 'product_ancestor_category',
          },
          {
            header: 'Inventory Count',
            field: 'inventory_count',
          },
          {
            header: 'Active Positions Count',
            field: 'active_positions_count',
          },
        ]}
        title="Inventory Summary"
        enabled={!!distributorId}
      />
    </>
  );
};
